export const DEFAULT_LANGUAGE = "en";
export const FALLBACK_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES_LABEL = ["en", "fr", "nl"];
export const SUPPORTED_LANGUAGES = [{
    "label": "en",
    "name": "English",
    "url": "http://dev-pro.immoweb.be/en",
    "isActive": false
},
{   "label": "fr",
    "name": "French",
    "url": "http://dev-pro.immoweb.be/fr",
    "isActive": false
},
{
    "label": "nl",
    "name": "Nederlands",
    "url": "http://dev-pro.immoweb.be/nl",
    "isActive": false
}];